import { IApplicationState } from '../../types/redux';

export const selectTotalCount = (state: IApplicationState) => {
  return state.buildersProjects.data.total;
};
